/**
 * El token de la invitación sobrevive al registro en `localStorage`
 * (spec 2026-09-11-invitaciones-equipo §3.3): si Supabase exige confirmar el mail, el
 * `?next=` se pierde en el viaje por la casilla, y `checkUserProfile` lo recupera de acá
 * antes de mandar al recién llegado al cuestionario.
 */
const KEY = 'atlas:invitacion';

export function guardarInvitacionPendiente(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    /* noop */
  }
}

export function leerInvitacionPendiente(): string | null {
  try {
    const t = localStorage.getItem(KEY);
    return t && /^[A-Za-z0-9_-]{16,64}$/.test(t) ? t : null;
  } catch {
    return null;
  }
}

export function olvidarInvitacionPendiente(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
